import React from 'react'
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons'
import { get } from 'lodash'
import { Button } from 'react-bootstrap'

const ViewEnrolleeesButton = ({
    experience = {},
    disabled,
    active,
    onClick = () => {}
}) => {
    const enrollees = get(experience, 'enrollees', [])

    if (disabled || !enrollees.length) {
        return null
    }

    const Icon = active ? EyeSlashFill : EyeFill
    const title = active ? 'Hide Enrollees' : 'Show Enrollees'
    return (
        <Button variant='link' onClick={() => onClick()} title={title}>
            <Icon />
        </Button>
    )
}

export default ViewEnrolleeesButton
